// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import store from './store'
import {Promptpai} from './assets/js/promptpai.js'
import {Utility} from './assets/js/utility.js'
import {messages} from './assets/lang/lang.js'
import QrcodeStream from '@/components/QrcodeStream.vue'
import QrcodeCapture from './components/QrcodeCapture.vue'
import * as firebase from 'firebase/app'
import 'firebase/messaging'
import { mapActions, mapGetters } from 'vuex'
import VueMeta from 'vue-meta'

window.gtag = () => {}

export function install (Vue) {
  Vue.component('qrcode-stream', QrcodeStream)
  Vue.component('qrcode-capture', QrcodeCapture)
}
export {
  QrcodeStream,
  QrcodeCapture
}
const plugin = { install }
export default plugin

const promptpai = new Promptpai()
const utility = new Utility()

if (utility.isFacebookWebview() || utility.isLineWebview()) {
  if (utility.isAndroidDevice()) {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.promptpai.promptpai&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
  } else { // ios
    window.location.href = 'https://apps.apple.com/us/app/%E0%B8%9E%E0%B8%A3-%E0%B8%AD%E0%B8%A1%E0%B9%84%E0%B8%9B/id1479832893?mt=8'
  }
}
document.addEventListener('touchmove', (event) => {
  if (event.touches.length > 1) {
    event.preventDefault()
  }
}, { passive: false })

var initFacebook = function (d, s, id) {
  var js
  var fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) {
    return
  }
  js = d.createElement(s); js.id = id
  js.addEventListener('load', function () {
    window.FB.init({
      appId: process.env.FACEBOOK_APP_ID,
      cookie: true,
      xfbml: true,
      version: 'v2.12'
    })
  })
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
}
initFacebook(document, 'script', 'facebook-jssdk')

var userAgent = utility.getUserAgentMeta()
if (window.liff) {
  if (userAgent !== 'Android application' && userAgent !== 'iOS application' && process.env.NODE_ENV !== 'development') {
    window.liff.init({ liffId: process.env.LIFF_ID }, () => {}, err => console.error(err.code, err.message))
  }
}

// copy cookie to localstorage [only once]
if (userAgent === 'iOS application') {
  var hasTranferCookieToLocalstorage = localStorage.getItem('hasTranferCookieToLocalstorage') !== null
  if (!hasTranferCookieToLocalstorage) {
    var keyList = ['deviceId', 'isAuthenticated', 'Uuid', 'lang', 'myPlaceTab', 'fcmToken', 'UserProfile']
    keyList.forEach((key) => {
      var value = VueCookies.get(key)
      if (value !== null) {
        localStorage.setItem(key, JSON.stringify(value))
      }
    })
    localStorage.setItem('hasTranferCookieToLocalstorage', JSON.stringify(true))
  }
}

Vue.use(plugin)
Vue.use(VueCookies)
Vue.use(VueI18n)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.config.productionTip = false

var isInitial = false
Vue.mixin({
  data () {
    return {
      pp: promptpai,
      util: utility
    }
  },
  computed: {
    ...mapGetters({
      itemsPerPage: 'myPlace/getItemsPerPage',
      recentList: 'myPlace/getRecentList',
      recentPage: 'myPlace/getRecentPage',
      favoriteList: 'myPlace/getFavoriteList',
      favoritePage: 'myPlace/getFavoritePage'
    })
  },
  mounted () {
    var self = this
    if (!isInitial) {
      isInitial = true
      self.initialApp()

      var myPlaceTab = JSON.parse(self.getPromptPaiCookies('myPlaceTab'))
      if (myPlaceTab === null) {
        self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Favorite'), Infinity, '/')
      }
      var lang = JSON.parse(self.getPromptPaiCookies('lang'))
      if (lang !== 'th' && lang !== 'en') {
        // if (window.navigator.language === 'th') {
        //   lang = 'th'
        // } else {
        //   lang = 'en'
        // }
        lang = 'th'
        self.setPromptPaiCookies('lang', JSON.stringify(lang), Infinity, '/')
      }
      self.$root.$i18n.locale = lang

      window.longdo.MapTheme.ui.fullscreenUp = self.util.getImagePath('maximize_btn@2x.png')
      window.longdo.MapTheme.ui.fullscreenDown = self.util.getImagePath('minimize_btn@2x.png')

      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'Android application' || userAgent === 'iOS application') {
        window.onTokenRefresh = (refreshedToken) => {
          self.refreshFcmToken(refreshedToken)
        }
        window.onNoti = (res) => {
          var payload = {
            data: res
          }
          if (payload.data.noti_type === 'receive_location') {
            self.$root.$emit('updateNumberReceivedLocation', payload.data.number_of_new_places)
            self.$root.$emit('refreshReceivedLocationList')
            // payload.data.sender = JSON.parse(payload.data.sender)
            payload.data.datetime = `${self.util.getDateString(payload.data.timestamp)} ${self.util.getTimeString(payload.data.timestamp)}`
            self.$root.$emit('alert', '', payload.data)
          }
          if (payload.data.noti_type === 'update_number_received_location') {
            self.$root.$emit('updateNumberReceivedLocation', payload.data.number_of_new_places)
            self.$root.$emit('refreshReceivedLocationList')
          }
        }
        window.location.href = 'https://native.getFcmToken'
      } else {
        window.firebase = firebase
        if (!window.firebase.apps.length) {
          var config = {
            apiKey: process.env.FIREBASE_API_KEY,
            authDomain: process.env.FIREBASE_AUTH_DOMAIN,
            databaseURL: process.env.FIREBASE_DATABASE_URL,
            projectId: process.env.FIREBASE_PROJECT_ID,
            storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID
          }
          window.firebase.initializeApp(config)
          if (window.firebase.messaging.isSupported()) {
            window.messaging = window.firebase.messaging()
            window.messaging.usePublicVapidKey(process.env.FIREBASE_USE_PUBLIC_VAPID_KEY)
            navigator.serviceWorker.register(process.env.FIREBASE_MESSAGING_SW).then(registration => {
              window.messaging.useServiceWorker(registration)
              window.messaging.onTokenRefresh(() => {
                window.messaging.getToken().then(self.refreshFcmToken).catch(err => {
                  console.log('Unable to retrieve refreshed token', err)
                })
              })
              window.messaging.onMessage(payload => {
                if (payload.data.noti_type === 'receive_location') {
                  self.$root.$emit('updateNumberReceivedLocation', payload.data.number_of_new_places)
                  self.$root.$emit('refreshReceivedLocationList')
                  payload.data.sender = JSON.parse(payload.data.sender)
                  payload.data.datetime = `${self.util.getDateString(payload.data.timestamp)} ${self.util.getTimeString(payload.data.timestamp)}`
                  self.$root.$emit('alert', '', payload.data)
                }
                if (payload.data.noti_type === 'update_number_received_location') {
                  self.$root.$emit('updateNumberReceivedLocation', payload.data.number_of_new_places)
                  self.$root.$emit('refreshReceivedLocationList')
                }
              })
            }).catch(err => {
              console.log('Unable to regist serviceWorker', err)
            })
          } else {
            self.setPromptPaiCookies('fcmToken', JSON.stringify(''), Infinity, '/')
          }
        }
      }

      window.addEventListener('resize', function () {
        self.$root.$emit('resize')
      })
      window.addEventListener('click', function (e) {
        self.$root.$emit('clickOnWindow', e)
      })
      window.addEventListener('touchstart', function (e) {
        self.$root.$emit('clickOnWindow', e)
      })
    }
  },
  methods: {
    ...mapActions({
      resetMyPlaceStore: 'myPlace/reset',
      setRecentList: 'myPlace/setRecentList',
      mergeRecentList: 'myPlace/mergeRecentList',
      setRecentPage: 'myPlace/setRecentPage',
      setFavoriteList: 'myPlace/setFavoriteList',
      mergeFavoriteList: 'myPlace/mergeFavoriteList',
      setFavoritePage: 'myPlace/setFavoritePage'
    }),
    initialApp () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        var temp = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        if (temp.longdousertoken !== '' && temp.longdousertoken !== null && temp.longdousertoken !== undefined && temp.uid !== '' && temp.uid !== null && temp.uid !== undefined) {
          userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
          uuid = undefined
        } else {
          self.setPromptPaiCookies('isAuthenticated', JSON.stringify(false), Infinity, '/')
          self.removePromptPaiCookies('UserProfile', '/')
          isAuthenticated = false
        }
      }
      if (!(!isAuthenticated && (uuid === undefined || uuid === null || uuid === ''))) {
        self.pp.initialApp(
          'name' in userProfile ? userProfile.name : undefined,
          'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
          isAuthenticated ? undefined : uuid,
          undefined,
          (result) => {
            if (result.status.code === 200) {
              self.$root.$emit('updateNumberReceivedLocation', result.data.number_of_new_places)
              self.$root.$emit('refreshReceivedLocationList')
            } else if (result.status.code === 401) {
              self.loginAgain()
            } else if (result.status.code === 403) {
            } else {
            }
          }
        )
      }
      window.longdoPdpa = new window.LongdoPDPA()
      window.longdoPdpa.init({
        lang: self.$i18n.locale,
        client: 'PromptPai',
        username: 'name' in userProfile ? userProfile.name : null,
        ldtoken: 'longdousertoken' in userProfile ? userProfile.longdousertoken : null,
        isForceHidePDPADialog: self.util.getUserAgentMeta() === 'iOS application' ||
          self.$route.name === 'UserQr' ||
          self.$route.name === 'PlaceQr' ||
          self.$route.name === 'Place' ||
          self.$route.name === 'Tel'
      })
    },
    loginAgain () {
      var self = this
      self.$router.replace('/?action=loginagain')
    },
    refreshFcmToken (refreshedToken, onFinish) {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.registerFcmToken(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        refreshedToken,
        JSON.parse(self.getPromptPaiCookies('deviceId')),
        undefined,
        (result) => {
          if (result.status.code === 200) {
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
          if (onFinish) {
            onFinish()
          }
        }
      )
    },
    setPromptPaiCookies (key, value) {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        localStorage.setItem(key, value)
      } else {
        self.$cookies.set(key, value, Infinity, '/')
      }
    },
    getPromptPaiCookies (key) {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        return localStorage.getItem(key)
      } else {
        return self.$cookies.get(key)
      }
    },
    isKeyPromptPaiCookies (key) {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        return localStorage.getItem(key) !== null
      } else {
        return self.$cookies.isKey(key)
      }
    },
    removePromptPaiCookies (key) {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        localStorage.removeItem(key)
      } else {
        self.$cookies.remove(key, '/')
      }
    }
  }
})

let initLang = ''
// if (window.navigator.language === 'th') {
//   initLang = 'th'
// } else {
//   initLang = 'en'
// }
initLang = 'th'

const i18n = new VueI18n({
  locale: initLang,
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js